import { USER_LOGIN_FETCH_REQUEST, USER_LOGIN_FETCH_SUCCESS, USER_LOGIN_FETCH_FAILURE, USER_LOGIN_EMPTY } from './types';

const initialState = {
    loading: false,
    login: {},
    error: ''
}

const login = (state = initialState, action) => {
    switch (action.type) {
        case USER_LOGIN_FETCH_REQUEST:
            return {
                loading: true,
                login: {},
                error: '',
            }
        case USER_LOGIN_FETCH_SUCCESS:
            return {
                loading: false,
                login: action.payload,
                error: ''
            }
        case USER_LOGIN_FETCH_FAILURE:
            return {
                loading: false,
                login: {},
                error: action.payload
            }
        case USER_LOGIN_EMPTY:
            return {
                loading: false,
                login: {},
                error: ''
            }
        default:
            return state
    }
}

export default login;